import React from 'react'
import styled from 'styled-components'
import { Select } from 'antd'
import Button from 'components/atoms/Button'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'frontend_core/dist/styles/colors'
import HelpTooltip from 'components/molecules/HelpTooltip'
// import Icon from 'components/atoms/FaIcon'
import Icon from 'components/atoms/Icon'

const Option = Select.Option

const Simulator = styled.div`
  position: relative;
  ${mediaMin.phone`
    position: absolute;
    bottom: 100px;
    right: 16px;
    padding: 0;
    z-index: 2;
    background-color: rgba(0,0,0,0);
    width: 340px;
  `} ${mediaMin.desktop`
  
  
  
    right: calc((100vw - 960px)/2);
  `};
`
const MSimuBalloon = styled.div`
  position: absolute;
  top: -125px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 4;
  ${mediaMin.phone`
    top: 50%;
    transform: translate(0, -50%);
    left: -40%;
  `};
`
const ASimuBalloon = styled.p`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);

  &::before {
    content: '';
    position: absolute;
    z-index: 2;
    background: ${Colors.white};
    width: 15px;
    height: 15px;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg) skew(20deg, 20deg);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    ${mediaMin.phone`
      top: 58%;
      left: 110px;
      transform: translateY(-50%) rotate(60deg) skew(-20deg,-20deg);
    `};
  }

  &::after {
    content: '';
    position: absolute;
    z-index: 3;
    background: ${Colors.white};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  & > * {
    position: relative;
    z-index: 4;
  }
`
const ASimuBalloonText = styled.span`
  position: relative;
  top: 40px;
  left: 16px;
  color: ${Colors.black};
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 1.2;
`
const SimulatorWrap = styled.div`
  background: ${Colors.white};
  max-width: 375px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
`
const SimulatorSimuTitleWrap = styled.div`
  background: ${Colors.black};
  padding: 14px 0;
  border-radius: 3px 3px 0 0 / 3px 3px 0 0;
`
const ASimuTitle = styled.h3`
  color: ${Colors.white};
  text-align: center;
  font-size: 16px;
  font-weight: bold;
`
const SimulatorContent = styled.div`
  padding: 16px 32px 24px;
`
const SimulatorItem = styled.div`
  &:not(:first-child) {
    margin-top: 8px;
  }
`
const SimulatorEstimateWrap = styled.div`
  padding: 16px 0 0;
  border-bottom: 1px solid ${Colors.grayD};

  &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const SimulatorEstimateWrapAEstimate = styled.div`
  display: inline-block;
  font-size: 13px;
  padding-top: 12px;
  float: left;
`
const SimulatorEstimateWrapAAmount = styled.p`
  display: inline-block;
  font-family: Arial, 'ＭＳ Ｐゴシック', sans-serif;
  font-size: 28px;
  color: ${Colors.black};
  font-weight: bold;
  text-align: right;
  float: right;
`
const SimulatorButtonWrap = styled.div`
  margin-top: 16px;

  & > div {
    display: block;
  }
`

const clickScroll = () => {
  const myMain = document.getElementById('applyhost')
  const rect = myMain.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  let myTop
  if (window.innerWidth > 768) {
    myTop = rect.top + scrollTop - 112
  } else {
    myTop = rect.top + scrollTop - 88
  }
  window.scrollTo(0, myTop)
}

export type PropTypes = {
  prefectureSelectProps: Object,
  prefecture: string,
  regionSelectProps: Object,
  region: string,
  capacitySelectProps: Object,
  capacity: string,
  price: string,
}

export default props => (
  <Simulator>
    <MSimuBalloon>
      <ASimuBalloon>
        <ASimuBalloonText>
          どのくらい<br />稼げるの？
        </ASimuBalloonText>
      </ASimuBalloon>
    </MSimuBalloon>
    <SimulatorWrap>
      <SimulatorSimuTitleWrap>
        <ASimuTitle>お持ちのスペースの収益をチェック！</ASimuTitle>
      </SimulatorSimuTitleWrap>
      <SimulatorContent>
        <SimulatorItem>
          <Select {...props.prefectureSelectProps}>
            {props.prefectureOptionList.map(({ value, label }, index) => (
              <Option key={index} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </SimulatorItem>
        <SimulatorItem>
          <Select {...props.regionSelectProps}>
            {props.regionOptionList.map(({ value, label }, index) => (
              <Option key={index} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </SimulatorItem>
        <SimulatorItem>
          <Select {...props.capacitySelectProps}>
            {props.capacityOptionList.map(({ value, label }, index) => (
              <Option key={index} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </SimulatorItem>
        <SimulatorEstimateWrap>
          <SimulatorEstimateWrapAEstimate>
            {i18n.t('page.hostEntry.expectedRevenue')}：
            <HelpTooltip
              beakHorizontalPosition="105px"
              beakHorizontalPositionSp="16px"
              positionType="left"
              left="-50px"
              text={i18n.t('page.hostEntry.expectedRevenueHint')}
            >
              <Icon type="question-circle" positionType="left" />
            </HelpTooltip>
          </SimulatorEstimateWrapAEstimate>
          <SimulatorEstimateWrapAAmount>
            <Icon className="fa fa-yen" iconSize="26" />
            {props.price}
          </SimulatorEstimateWrapAAmount>
        </SimulatorEstimateWrap>
        <SimulatorButtonWrap>
          <Button
            buttonType="large"
            colorType="green"
            onClick={props.onClick}
            fontWeight
            buttonWidthPc="276"
            buttonHeightPc="42"
            fullWidthSp
            buttonHeightPc="46"
          >
            {i18n.t('page.hostEntry.registOwner')}
          </Button>
        </SimulatorButtonWrap>
      </SimulatorContent>
    </SimulatorWrap>
  </Simulator>
)
